import { Request } from 'commons/utils/request'
import { DateTime, DownloadLink, TableActions, TableColumn, Toast } from 'ui/components'

import { Files } from './types'

export const columns = (
  startDeleting: (id: number) => void,
  startUpdating: ({ id, name }: { id: number; name: string }) => void
): TableColumn<Files>[] => [
  {
    key: 'fileName',
    title: 'Filename',
    align: 'left',
    render: (item) => (
      <DownloadLink
        direct
        parametersForm={{ id: item.fileId }}
        baseUrl={Request.urls.bank.applicationClientDocumentFileDirectDownload}
        name={item.fileName}
        handleError={(message: string) => Toast.error('Error', message)}
      >
        {item.fileName}
      </DownloadLink>
    )
  },
  {
    key: 'fileCreatedAt',
    title: 'Uploaded Date',
    align: 'left',
    render: ({ fileCreatedAt }) => <DateTime date={fileCreatedAt} withTime />
  },
  {
    key: 'fileId',
    title: 'Actions',
    align: 'left',
    width: '50px',
    render: ({ fileId, fileName }) => (
      <TableActions
        items={[
          {
            type: 'edit',
            onClick: () => startUpdating({ id: fileId, name: fileName })
          },
          {
            type: 'delete',
            onClick: () => startDeleting(fileId)
          }
        ]}
      />
    )
  }
]
